import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

import {
    lightCategoryColors,
    lightPillarColors,
    mediumCategoryColors,
    mediumPillarColors,
    PillarSlug,
    strongCategoryColors,
    strongPillarColors
} from "../../../thematics/colors";
import { Thematic } from "../../../thematics/models/thematic.model";
import { Tag } from "../tags/tags.component";

@Component({
    selector: 'app-content-thematic',
    templateUrl: './content-thematic.component.html',
    styleUrls: ['./content-thematic.component.scss'],
})

export class ContentThematicCardComponent implements OnInit, OnChanges {
    
    public tags$ = new BehaviorSubject<Tag[]>([]);
    
    colorMedium!: string;

    colorStrong!: string;
  
    colorLight!: string;

    hovered = false;
    
    @Input() thematic!: Thematic;

    @Input() big = false;

    @Input() imageWidth?: number;
    
    @Input() imageHeight?: number;

    constructor(private readonly router: Router) {
        
    }

    ngOnInit() {
        // Use category colors if available, otherwise fallback to pillar colors
        const pillarName = this.thematic.pillar?.name as PillarSlug;
        const categorySlug = this.thematic.category?.slug;

        this.colorMedium = categorySlug
            ? mediumCategoryColors[categorySlug]
            : (pillarName ? mediumPillarColors[pillarName] : '');
        this.colorStrong = categorySlug
            ? strongCategoryColors[categorySlug]
            : (pillarName ? strongPillarColors[pillarName] : '');
        this.colorLight = categorySlug
            ? lightCategoryColors[categorySlug]
            : (pillarName ? lightPillarColors[pillarName] : '');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.thematic) {
          this.tags$.next(changes.thematic.currentValue.tags);
        }
    }

    onMouseOver(event: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.hovered = true;
    }
    
    onMouseLeave(event: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.hovered = false;
    }

    clickOnThematic(slug: string) {
        this.router.navigate([ 'thematics', slug ]);
      }
}